<div class="main-content">
  <strong class="currency-info">{{ currencyCode }}</strong>
  <input [disabled]="disabled" #moneyInput (input)="onInputChange($event)" />
</div>
